/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People3Icon16Solid = forwardRef('People3Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.238 5a2.238 2.238 0 1 1-4.476 0 2.238 2.238 0 0 1 4.476 0Z" }),
        React.createElement("path", { d: "M15 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M12.866 13h2.14a.993.993 0 0 0 .994-.993C16 9.604 14.049 9 12.5 9l-.175.003c.425.702.675 1.61.675 2.757v.74a.996.996 0 0 1-.134.5Z" }),
        React.createElement("path", { d: "M3.675 9.003A5.92 5.92 0 0 0 3.5 9C1.951 9 0 9.604 0 12.007c0 .549.445.993.993.993h2.141A.996.996 0 0 1 3 12.5v-.74c0-1.147.25-2.055.675-2.757Z" }),
        React.createElement("path", { d: "M3 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M11.998 11.758C11.998 8.755 9.769 8 8 8c-1.77 0-3.998.755-3.998 3.758V12a1 1 0 0 0 1 1h5.996a1 1 0 0 0 1-1v-.242Z" })));
});
